document.addEventListener("DOMContentLoaded", function() {
  
  if ( document.body.clientWidth > 989 ) {
    var swiper = new Swiper(".swiper-collection-list", {
      slidesPerView: 3,
      spaceBetween: 16,
      scrollbar: {
        el: ".collection-list-swiper-scrollbar",
      },
    });
  
    var swiper = new Swiper(".swiper-product-list", {
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  // pdp make offer btn -- START
  let makeOffer = document.querySelector("[data-make-offer-btn]") || null;
  if(makeOffer){
    makeOffer.addEventListener("click",function(e){
      e.preventDefault();
      document.body.classList.add("offer-popup-active");
    });
  }
  let makeOfferClose = document.querySelector(".offer-form-popup .icon-close-btn") || null;
  if(makeOfferClose){
    makeOfferClose.addEventListener("click",function(e){
      e.preventDefault();
      document.body.classList.remove("offer-popup-active");
    });
  }
  let makeOfferCloseOverlay = document.querySelector(".offer-form-popup") || null;
  if(makeOfferCloseOverlay){
    makeOfferCloseOverlay.addEventListener("click",function(e){
      e.preventDefault();
      let inner = document.querySelector(".offer-form-inner") || null;
      if(e.target != inner && !e.target.closest(".offer-form-inner")){
        document.body.classList.remove("offer-popup-active");
      }
    });
  }
  // pdp make offer btn -- END
  
});

// PRODUCT PAGE ACORDION slipt using liquid code 

function toggleAccordion(element) {
  var content = element.nextElementSibling; // Selects the next sibling, which is the accordion-content
  var allContents = document.querySelectorAll('.accordion-content');

  allContents.forEach(function(cont) {
    if (cont !== content) {
      cont.style.maxHeight = null; // Collapse all other accordion contents
      cont.parentElement.classList.remove('openClass'); // Remove openClass from other accordion-items
    }
  });

  // Toggle the current accordion content
  if (content.style.maxHeight) {
    content.style.maxHeight = null; // Collapse if it's already expanded
    element.parentElement.classList.remove('openClass'); // Remove openClass from current accordion-item
  } else {
    content.style.maxHeight = content.scrollHeight + 'px'; // Expand to the full height of the content
    element.parentElement.classList.add('openClass'); // Add openClass to current accordion-item
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var titles = document.querySelectorAll('.accordion-title'); // Select all elements with class accordion-title
  titles.forEach(function(title) {
    title.addEventListener('click', function() {
      toggleAccordion(title); // Call toggleAccordion function on click
    });
  });
});


// price filter slider
document.addEventListener('DOMContentLoaded', () => {
  const rangeMin = document.querySelector('.range-min');
  const rangeMax = document.querySelector('.range-max');
  const minValueInput = document.querySelector('.minvalue');
  const maxValueInput = document.querySelector('.maxvalue');
  const progress = document.querySelector('.price-range-progress');
  function updateInputs() {
    console.log("range-update!!!");
    if (minValueInput) minValueInput.value = rangeMin.value;
    if (maxValueInput) maxValueInput.value = rangeMax.value;
  }

  function updateSlider() {
    if (minValueInput && maxValueInput) {
      rangeMin.value = minValueInput.value;
      rangeMax.value = maxValueInput.value;
    }
    updateProgress();
  }

  function updateProgress() {
    const minPercent = (rangeMin.value / rangeMin.max) * 100;
    const maxPercent = (rangeMax.value / rangeMax.max) * 100;
    progress.style.left = minPercent + '%';
    progress.style.right = (100 - maxPercent) + '%';
  }

  rangeMin.addEventListener('input', () => {
    if (parseInt(rangeMin.value) > parseInt(rangeMax.value)) {
      rangeMin.value = rangeMax.value;
    }
    updateInputs();
    updateProgress();
  });

  rangeMax.addEventListener('input', () => {
    if (parseInt(rangeMax.value) < parseInt(rangeMin.value)) {
      rangeMax.value = rangeMin.value;
    }
    updateInputs();
    updateProgress();
  });

  minValueInput.addEventListener('change', () => {
    if (parseInt(minValueInput.value) > parseInt(rangeMax.value)) {
      minValueInput.value = rangeMax.value;
    }
    updateSlider();
  });

  maxValueInput.addEventListener('change', () => {
    if (parseInt(maxValueInput.value) < parseInt(rangeMin.value)) {
      maxValueInput.value = rangeMin.value;
    }
    updateSlider();
  });
  // Initial update
  updateInputs();
  updateProgress();
});


// price range for mobile 

document.addEventListener('DOMContentLoaded', () => {
  const mobileRangeMin = document.querySelector('.mobile-range-min');
  const mobileRangeMax = document.querySelector('.mobile-range-max');
  const mobileMinValueInput = document.querySelector('.Mobile-Filter--minvalue');
  const mobileMaxValueInput = document.querySelector('.Mobile-Filter--maxvalue');
  const mobileProgress = document.querySelector('.mobile-price-rang');
  const removeButton = document.querySelector('.mobile-price-range');

  if (!mobileRangeMin || !mobileRangeMax || !mobileMinValueInput || !mobileMaxValueInput || !mobileProgress) {
    console.error('One or more elements not found. Check your HTML structure and class names.');
    return;
  }

  function updateInputs() {
    mobileMinValueInput.value = mobileRangeMin.value;
    mobileMaxValueInput.value = mobileRangeMax.value;
  }

  function updateSlider() {
    mobileRangeMin.value = mobileMinValueInput.value;
    mobileRangeMax.value = mobileMaxValueInput.value;
    updateProgress();
  }

  function updateProgress() {
    const minPercent = (mobileRangeMin.value / mobileRangeMin.max) * 100;
    const maxPercent = (mobileRangeMax.value / mobileRangeMax.max) * 100;
    mobileProgress.style.left = minPercent + '%';
    mobileProgress.style.right = (100 - maxPercent) + '%';
  }

  mobileRangeMin.addEventListener('input', () => {
    if (parseInt(mobileRangeMin.value) > parseInt(mobileRangeMax.value)) {
      mobileRangeMin.value = mobileRangeMax.value;
    }
    updateInputs();
    updateProgress();
  });

  mobileRangeMax.addEventListener('input', () => {
    if (parseInt(mobileRangeMax.value) < parseInt(mobileRangeMin.value)) {
      mobileRangeMax.value = mobileRangeMin.value;
    }
    updateInputs();
    updateProgress();
  });

  mobileMinValueInput.addEventListener('change', () => {
    if (parseInt(mobileMinValueInput.value) > parseInt(mobileRangeMax.value)) {
      mobileMinValueInput.value = mobileRangeMax.value;
    }
    updateSlider();
  });

  mobileMaxValueInput.addEventListener('change', () => {
    if (parseInt(mobileMaxValueInput.value) < parseInt(mobileRangeMin.value)) {
      mobileMaxValueInput.value = mobileRangeMin.value;
    }
    updateSlider();
  });
/* removeButton.addEventListener('click', () => {
  console.log("Button clicked");
  updateInputs();
  updateProgress();
}); */
  // Initial update
  updateInputs();
  updateProgress();
});


// offer form click event 
$(document).ready(function(){

  $('.offer-form-btn').click(function(event){
    console.log("click validation!!!");
  // $('.error-message').removeClass('hidden');
    event.preventDefault();
    var form = $('#OfferForm')[0];
    var isValid = true;

    // Validate each field before form submission
    $('#OfferForm .field__input, #OfferForm .text-area').each(function(){
      var field = $(this)[0];
      var fieldId = $(this).attr('id');
      var errorMessageElement = $('#' + fieldId + '-error');

      // Reset previous error message
      errorMessageElement.text('').css('color', 'red');

      if (!field.checkValidity()) {
        isValid = false;
        var errorMessage = 'Please enter ' + $(this).attr('placeholder').toLowerCase() + '.';
        errorMessageElement.text(errorMessage);
        $(this).attr('aria-invalid', 'true');
      } else {
        $(this).attr('aria-invalid', 'false');
      }
    });

    // If form is valid, submit the form
    if (isValid) {
      form.submit();
    }
  });

  // Additional: Validate on input field focusout (optional)
    $('#OfferForm .field__input, #OfferForm .text-area').on('change', function() {
    var isValid = true;
    var fieldId = $(this).attr('id');
    var errorMessageElement = $('#' + fieldId + '-error');

    // Reset previous error message
    errorMessageElement.text('').css('color', 'red');

    if (!this.checkValidity()) {
      isValid = false;
      var errorMessage = 'Please enter ' + $(this).attr('placeholder').toLowerCase() + '.';
      errorMessageElement.text(errorMessage);
      $(this).attr('aria-invalid', 'true');
    } else {
      $(this).attr('aria-invalid', 'false');
    }
  });
});

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
 item.addEventListener("mouseover", () => {
  item.setAttribute("open", true);
   item.querySelector("ul").addEventListener("mouseleave", () => {
     item.removeAttribute("open");
   });
   item.addEventListener("mouseleave", () => {
     item.removeAttribute("open");
   });
 });
});
